<script>
import WorkflowNodes from './Workflows.vue';
import DeleteWorkflowDialog from './components/DeleteWorkflowDialog.vue';
import CreateWorkflowDialog from './components/CreateWorkflowDialog.vue';
import EditWorkflowDialog from './components/EditWorkflowDialog.vue';
import CreateStageDialog from './components/CreateStageDialog.vue';
import EditStageDialog from './components/EditStageDialog.vue';
import DeleteStageDialog from './components/DeleteStageDialog.vue';

export default {
  components: {
    WorkflowNodes,
    CreateWorkflowDialog,
    EditWorkflowDialog,
    DeleteWorkflowDialog,
    CreateStageDialog,
    EditStageDialog,
    DeleteStageDialog,
  },
  props: {
    bot: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$store.dispatch('wgptBotWorkflowStages/clear');
  },
  methods: {
    showAddWorkflowPopup() {
      this.$refs.createWorkflowDialog?.open();
    },
    showEditWorkflowPopup(selectedWorkflow) {
      this.$refs.editWorkflowDialog?.open(this.bot, selectedWorkflow);
    },
    showDeleteWorkflowPopup(selectedWorkflow) {
      this.$refs.deleteWorkflowDialogRef?.open(this.bot, selectedWorkflow);
    },
    showAddStagePopup(selectedWorkflow) {
      this.$refs.createStageDialog?.open(this.bot, selectedWorkflow);
    },
    showEditStagePopup(selectedStage, selectedWorkflow) {
      this.$refs.editStageDialog?.open(
        this.bot,
        selectedWorkflow,
        selectedStage
      );
    },
    showDeleteStagePopup(selectedStage, selectedWorkflow) {
      this.$refs.deleteStageDialog?.open(
        this.bot,
        selectedWorkflow,
        selectedStage
      );
    },
  },
};
</script>

<template>
  <div
    class="overflow-auto h-full py-8 bg-[radial-gradient(#ebf0f5_1.2px,transparent_0)] dark:bg-[radial-gradient(#293f51_1.2px,transparent_0)] bg-[length:1rem_1rem]"
  >
    <WorkflowNodes
      :bot="bot"
      @add-workflow="showAddWorkflowPopup"
      @edit-workflow="showEditWorkflowPopup"
      @delete-workflow="showDeleteWorkflowPopup"
      @add-stage="showAddStagePopup"
      @edit-stage="showEditStagePopup"
      @delete-stage="showDeleteStagePopup"
    />

    <CreateWorkflowDialog ref="createWorkflowDialog" />

    <EditWorkflowDialog ref="editWorkflowDialog" />

    <DeleteStageDialog ref="deleteStageDialog" />

    <CreateStageDialog ref="createStageDialog" />

    <EditStageDialog ref="editStageDialog" />

    <DeleteWorkflowDialog ref="deleteWorkflowDialogRef" />
  </div>
</template>
